import { useQuery } from "@tanstack/react-query";
import { qk } from "../../lib/queryKeys";
import { getJson } from "../../lib/http";
import { useCompaniesStore } from "../../store/admin/companiesStore";
import type { TrackingReplay } from "../../store/admin/trackingReplaysStore";

export interface TrackingReplayListParams {
  page?: number;
  limit?: number;
}

interface ListMeta {
  error: string | null;
  count: number;
  status: number;
  currentPage: number;
  totalPages: number;
  totalItems: number;
  url: string;
}

interface TrackingReplayListBody {
  data?: TrackingReplay[];
  meta?: ListMeta;
}

export interface TrackingReplayListResult {
  data: TrackingReplay[];
  meta?: ListMeta;
}

export function useTrackingReplaysList(params: TrackingReplayListParams = {}) {
  const companyId = useCompaniesStore((s) => s.companyId);
  return useQuery({
    queryKey: qk.trackingReplays.list(companyId, params),
    queryFn: ({ signal }) =>
      getJson<TrackingReplayListBody>(
        "/trackingReplaysList",
        {
          page: params.page ?? 1,
          limit: params.limit ?? 8,
          ...(companyId ? { company_id: companyId } : {}),
        },
        { signal },
      ).then((body) => ({ data: body.data ?? [], meta: body.meta })),
  });
}
